export default {
  "button": "_button_1c8mi_1",
  "tabButton": "_tabButton_1c8mi_1",
  "active": "_active_1c8mi_1",
  "animatedLine": "_animatedLine_1c8mi_5",
  "focusable": "_focusable_1c8mi_10",
  "focusRing": "_focusRing_1c8mi_14"
};import "ni:sha-256;6sTGdu1G7LGbE5gx_b13AKkvU2PgSMm_X0AWuiArJ2U";